import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-blue-600 text-white shadow-lg">
        <div className="container mx-auto px-4 py-6">
          <Link to="/" className="text-4xl font-bold hover:text-blue-100 transition">📰 NotíciasWeb</Link>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-800 mb-8">Sobre o NotíciasWeb</h1>
        
        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-700 mb-6">
              O NotíciasWeb é seu portal de notícias completo, trazendo as últimas informações 
              sobre política, economia, esporte, tecnologia, saúde e entretenimento.
            </p>

            <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Nossa Missão</h2>
            <p className="text-gray-700 mb-6">
              Fornecer informações precisas, atualizadas e relevantes para nossos leitores, 
              mantendo sempre os mais altos padrões de jornalismo e ética.
            </p>

            <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Nossos Valores</h2>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li className="mb-2">
                <strong>Credibilidade:</strong> Todas as notícias são verificadas e baseadas em fontes confiáveis
              </li>
              <li className="mb-2">
                <strong>Imparcialidade:</strong> Apresentamos os fatos de forma equilibrada e objetiva
              </li>
              <li className="mb-2">
                <strong>Atualização:</strong> Mantemos nosso conteúdo sempre atualizado com as últimas novidades
              </li>
              <li className="mb-2">
                <strong>Acessibilidade:</strong> Disponibilizamos informação de qualidade para todos
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Nossa Equipe</h2>
            <p className="text-gray-700 mb-6">
              Contamos com uma equipe de jornalistas experientes e especializados em diversas áreas, 
              garantindo cobertura completa e aprofundada dos principais acontecimentos.
            </p>

            <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">Contato</h2>
            <p className="text-gray-700 mb-4">
              Tem alguma sugestão, crítica ou dúvida? Entre em contato conosco!
            </p>
            <Link 
              to="/contato" 
              className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            >
              Fale Conosco
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default About;